module.exports = __webpack_public_path__ + "static/media/bill-to-ship-to-address-popup.2564500b.png";